import { render, staticRenderFns } from "./EditProvider.vue?vue&type=template&id=5a28e19f&"
import script from "./EditProvider.vue?vue&type=script&lang=js&"
export * from "./EditProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports